import {
  RoomDescription,
  roomDescription,
  roomStartAt,
  RoomStartAt,
  RoomTitle,
  roomTitle
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomCreateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomCreateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomCreateRequestDTORaw) {
    JsonSchemaValidator.assert(RoomCreateRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["title"],
      properties: {
        title: roomTitle,
        description: roomDescription,
        startAt: roomStartAt
      },
      additionalProperties: false
    };
  }
}

interface RoomCreateRequestDTORaw {
  title: RoomTitle;
  description?: RoomDescription;
  startAt?: RoomStartAt;
}
